// Translation: Two-factor authentication > Landing > Form (Arabic)
export default Object.freeze({
	form: {
		actions: {
			activate: '',
			reload: '',
			skip: ''
		},
		fallback: {
			message: ''
		},
		fields: {
			code: {
				placeholder: ''
			}
		},
		title: ''
	}
})
